import { useFormState } from "react-final-form";
import { FunctionField } from "react-admin";
import { getDependencyDegree, getLikes, getTechnologicalIndependence, getTherapeuticProfile, getUsesTechHelp } from "../../services/master-tables.service";
import { useEffect, useState } from "react";
import { GetApp } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import AffinitiesProvider from "../../provider/affinities.provider";

import moment from "moment";

import { saveAs } from 'file-saver';
var XLSX = require("xlsx");

export const PanelObservaciones = (props) => {
    const [gradoDependencia, setGradoDependencia] = useState()
    const [gustos, setGustos] = useState()
    const [perfilTerapeutico, setPerfilTerapeutico] = useState()
    const [autonomia, setAutonomia] = useState()
    const [ayudaTecnica, setAyudaTecnica] = useState()
    const [affinities, setAffinities] = useState([]);

    const { values } = useFormState();

    useEffect(() => {

        const fetchAffinities = async () => {
            var resp = await AffinitiesProvider?.GetAffinityForUser({ clientId: values?.id });

            if (resp && Array.isArray(resp)) {
                const ordered = resp.map(affinity => {
                    if (affinity.clientBId === values?.id) {
                        // Intercambia A y B para que el usuario que estamos consultando quede como clientA
                        return {
                            ...affinity,
                            clientAId: affinity.clientBId,
                            clientAName: affinity.clientBName,
                            clientBId: affinity.clientAId,
                            clientBName: affinity.clientAName
                        };
                    }
                    return affinity; 
                });
    
                setAffinities(ordered);
            }
        };

        if (values?.id) {
            fetchAffinities();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getDependencyDegree().then(res => setGradoDependencia(res.elements.find(e => e.id === values.dependencyDegreeId)?.value))
        getLikes().then(res => setGustos(res.elements))
        getTherapeuticProfile().then(res => setPerfilTerapeutico(res.elements))
        getTechnologicalIndependence().then(res => setAutonomia(res.elements.find(e => e.id === values.technologicalIndependenceId)?.value))
        getUsesTechHelp().then(res => setAyudaTecnica(res.elements.find(e => e.id === values.usesTechHelpId)?.value))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const descargar = () => {
        const xlsxBlob = arrayToXlsx([{
            Perfil_Asistencia: values?.therapeuticalProfiles?.map(l => perfilTerapeutico?.find(p => p.id === l)?.value)?.join(', '),
            Autonomía: autonomia,
            Ayudas_Técnicas: (ayudaTecnica || '') + " " + (ayudaTecnica ? (values?.whichOnesTechHelp || '') : ''),
            Grado_Dependencia: gradoDependencia,
            Gustos_Preferencias: values?.clientLikes?.map(l => gustos?.find(g => g.id === l)?.value)?.join(', '),
            Personas_Contacto: props.contactos?.map(c => renderContact(c))?.join(', '),
            Psicólogo_Referencia: values?.supportProfessional?.name + " " + values?.supportProfessional?.surnames,
            Trabajador_Social_Referencia: values?.referenceSocialWorker?.name + " " + values?.referenceSocialWorker?.surnames
        }]);
        saveAs(xlsxBlob, `Observaciones_${values.identificationNumber}_${values.name}_${values.surnames}_${moment().format('YYYY-MM-DD hh:mm')}.xlsx`.replaceAll(' ', '_'));
    }

    const arrayToXlsx = (array) => {
        const worksheet = XLSX.utils.json_to_sheet(array);
        const columnWidths = Object.keys(array[0]).map((col) => {
            const maxWidth = array.reduce((max, row) => Math.max(max, (row[col] || "").toString().length), 10);
            return { wch: maxWidth + 5 }; // Ajusta el margen sumando un valor adicional
        });
        worksheet["!cols"] = columnWidths;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const xlsxBlob = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        return new Blob([xlsxBlob], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    };

    return (
        <div style={{
            display: 'flex', flexDirection: 'row', gap: 14
        }}>
            <div style={{
                display: 'flex', flexDirection: 'column', gap: 12,
                backgroundColor: '#f0f0f0', borderRadius: '8px', padding: 8, width: '70%'
            }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h3>Observaciones generales</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, paddingLeft: '1rem' }}>
                        <GetApp style={{ color: "#00ab8e", cursor: "pointer" }} onClick={descargar} />
                    </div>
                </div>
                <div className="divide-x"
                    style={{
                        display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr',
                        width: '100%'
                    }}>
                    <div style={{ display: 'grid', gap: 3, gridTemplateRows: 'auto auto auto', height: '100%' }}>
                        <div>
                            <FunctionField render={record => "Perfil de asistencia: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => record?.therapeuticalProfiles?.map(l => perfilTerapeutico?.find(p => p.id === l)?.value)?.join(', ')} />
                        </div>

                        <div>
                            <FunctionField render={record => "Autonomía: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => (autonomia || '')} />
                        </div>

                        <div>
                            <FunctionField render={record => "Ayudas técnicas: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => (ayudaTecnica || '') + " " + (ayudaTecnica ? (record?.whichOnesTechHelp || '') : '')} />
                        </div>
                    </div>
                    <div style={{ display: 'grid', gap: 3, gridTemplateRows: 'auto auto auto', height: '100%', paddingLeft: '1rem' }}>
                        <div>
                            <FunctionField render={record => "Grado de dependencia: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => (gradoDependencia || '')} />
                        </div>

                        <div>
                            <FunctionField render={record => "Gustos/Preferencias: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => record?.clientLikes?.map(l => gustos?.find(g => g.id === l)?.value)?.join(', ')} />
                        </div>
                    </div>
                    <div style={{ display: 'grid', gap: 3, gridTemplateRows: 'auto auto auto', height: '100%', paddingLeft: '1rem', gridColumn: '3/5' }}>
                        <Tooltip title={ReactHtmlParser(props.contactos?.length > 3 ? props.contactos?.map(c => renderContact(c))?.join('<br>') : '')} placement="right">
                            <span>
                                <FunctionField render={record => "Personas de contacto: "} />
                                <FunctionField style={{ fontWeight: 'bold' }} render={record => props.contactos?.slice(0, 3)?.map(c => renderContact(c))?.join(', ') + (props.contactos?.length > 3 ? '...' : '')} />
                            </span>
                        </Tooltip>
                        <div>
                            <FunctionField render={record => "Psicólogo de referencia: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => record?.supportProfessional?.name + " " + record?.supportProfessional?.surnames} />
                        </div>
                        <div>
                            <FunctionField render={record => "Trabajador social de referencia: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => record?.referenceSocialWorker?.name + " " + record?.referenceSocialWorker?.surnames} />
                        </div>
                    </div>
                </div>
            </div>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
                width: '30%',
                backgroundColor: '#f0f0f0',
                borderRadius: '8px',
                padding: 8
            }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h3>Usuarios con Afinidad</h3>
                </div>
                <div style={{ width: '100%' }}>


                    {affinities && affinities.length > 0 ? affinities.map((affinity, index) => (
                        <div key={index} style={{
                            display: 'flex',
                            flexDirection: 'row',
                            margin: '5px',
                            alignItems: 'center' // Añadido para alinear verticalmente
                        }}>
                            {/* Primer usuario */}
                            {/* <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '40%' // Ancho fijo para alinear
                            }}>
                                <div style={{
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '50%',
                                    backgroundColor: affinity?.clientAId === values?.id ? '#00ab8e' : '#003488',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    {affinity.clientAName.charAt(0)}{affinity.clientAName.split(' ')[1].charAt(0)}
                                </div>
                                <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>{affinity.clientAName}</span>
                            </div> */}

                            {/* Segundo usuario */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '40%', // Ancho fijo para alinear
                                marginLeft: '0px' // Ajustado
                            }}>
                                <div style={{
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '50%',
                                    backgroundColor: affinity?.clientBId === values?.id ? '#00ab8e' : '#003488',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    {affinity.clientBName.charAt(0)}{affinity.clientBName.split(' ')[1].charAt(0)}
                                </div>
                                <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>{affinity.clientBName}</span>
                            </div>

                            {/* Afinidad */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                                width: '20%', // Ancho fijo
                                marginLeft: '0px' // Ajustado
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                                        Afinidad: {affinity?.affinityScore}%
                                    </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    height: '8px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    position: 'relative'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        left: '50%',
                                        width: '1px',
                                        height: '100%',
                                        backgroundColor: '#999',
                                        zIndex: 1
                                    }}></div>
                                    <div style={{
                                        width: `${Math.abs((affinity?.affinityScore/2))}%`,
                                        backgroundColor: affinity?.affinityScore > 0 ? '#4CAF50' :
                                            affinity?.affinityScore < 0 ? '#F44336' : 'transparent',
                                        position: 'absolute',
                                        left: affinity?.affinityScore > 0 ? '50%' : `${50 - Math.abs((affinity?.affinityScore/2))}%`,
                                        height: '100%'
                                    }}></div>
                                </div>
                                <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                fontSize: '10px'
                            }}>
                                <span>-100</span>
                                <span>0</span>
                                <span>+100</span>
                            </div>
                            </div>
                        </div>
                    )): <div> No tiene afinidad</div>}
                </div>
            </div>
        </div>


    );
}

const renderContact = (c) => {
    var data = ""
    if (c.name && c.surnames) data = c.name + " " + c.surnames
    else if (c.name) data = c.name
    else if (c.surnames) data = c.surnames
    else if (c.phone1) data = c.phone1
    else if (c.phone2) data = c.phone2
    else if (c.email) data = c.email

    return data
}